var _rect, _text, _rect2, _rect3, _rect4, _rect5, _circle, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestimonial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 240",
    width: 800,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 240,
    rx: 16,
    fill: "#f7fbff",
    stroke: "#dbe9f6"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 90,
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontWeight: 700,
    fontSize: 80,
    fill: "#e3edf8"
  }, "\u201C")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 70,
    width: 680,
    height: 100,
    rx: 12,
    fill: "#ffffff",
    stroke: "#e6edf3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 90,
    width: 640,
    height: 12,
    rx: 6,
    fill: "#cfe3f7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 110,
    width: 520,
    height: 10,
    rx: 5,
    fill: "#e6edf3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 130,
    width: 580,
    height: 10,
    rx: 5,
    fill: "#e6edf3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 190,
    r: 18,
    fill: "#e8f1ff",
    stroke: "#cfe3f7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 180,
    width: 200,
    height: 12,
    rx: 6,
    fill: "#cfe3f7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonial);
export default __webpack_public_path__ + "static/media/testimonial.c81ef0d87d8edadb99ab1308e8733e54.svg";
export { ForwardRef as ReactComponent };